import styles from 'crazyEditor/components/Toolbar/GlobalControls/GlobalControlsStyles';
import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import FlatButton from 'material-ui/FlatButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'shared/components/MenuItem';
import routes from 'App/routeConstants';
import {Link} from 'react-router';
import * as Colors from 'material-ui/styles/colors';

const NextButton = ({bulkReviseEnabled, isTemplate}) => {
  if (!isTemplate || !bulkReviseEnabled) {
    return null;
  }

  return (
    <IconMenu
      style={{height: '100%'}}
      iconButtonElement={<FlatButton
        style={{height: '100%'}}
        {...styles.primaryButtonProperties}
        labelStyle={{color: Colors.white}}
        label="next"/>}
      anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
      targetOrigin={{horizontal: 'right', vertical: 'top'}}
    >
      <MenuItem
        primaryText="Listings page"
        tooltip={<div>
          <div style={{textTransform: 'uppercase'}}>Listings page</div>
          <div style={{lineHeight: '130%', paddingBottom: 10}}>Go to the Listings page to apply your template
            one-by-one or in bulk.
          </div>
        </div>}
        containerElement={<Link to={{
          pathname: routes.MyAccount.Listings,
        }}/>}
      />
      <MenuItem
        primaryText="My Templates page"
        tooltip={<div>
          <div style={{textTransform: 'uppercase'}}>My Templates page</div>
          <div style={{lineHeight: '130%', paddingBottom: 10}}>Go to the My Templates page to manage your templates.
          </div>
        </div>}
        containerElement={<Link to={{
          pathname: routes.MyAccount.ViewTemplatesBase,
        }}/>}
      />
    </IconMenu>
  );
};

export default connect((state) => {
  return ({
    bulkReviseEnabled: state.user.bulkReviseEnabled,
    isTemplate: _.isEmpty(state.listingData),
  });
})(NextButton);